import * as React from 'react';

export interface ILocationSectionProps extends React.PropsWithChildren {}

export const LocationSection: React.FunctionComponent<
  ILocationSectionProps
> = props => {
  return <div className='grid grid-cols-6'>{props.children}</div>;
};
